__turbopack_context__.v({
  "container": "stats-module-scss-module___oYzSq__container",
  "number": "stats-module-scss-module___oYzSq__number",
  "numberText": "stats-module-scss-module___oYzSq__numberText",
  "numberTitle": "stats-module-scss-module___oYzSq__numberTitle",
  "numbers": "stats-module-scss-module___oYzSq__numbers",
  "rating_star": "stats-module-scss-module___oYzSq__rating_star",
});
